import {decode,DecodeOptions,JwtPayload} from 'jsonwebtoken';


const decodeJwtToken = (token, options) => {
    return decode(token, options);
};
export {
    decodeJwtToken,
};